import { getProtectedInstance } from "../utils/axiosInstance";

export const getFoodTotalExpenseDownloadService = async (fromDate: any, toDate: any) => {
    const response = await getProtectedInstance().get(
        `/report/food?from_date=${fromDate}&to_date=${toDate}&download=true`
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${response?.headers['content-disposition']?.split('=')[1] || 'FoodReport.csv'}`);
    document.body.appendChild(link);
    link.click();
    // return response;
};
export const getCmpFoodTotalExpenseDownloadService = async (fromDate: any, toDate: any, companyId: string) => {
    const response = await getProtectedInstance().get(
        `/report/company/${companyId}/food?from_date=${fromDate}&to_date=${toDate}&download=true`
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${response?.headers['content-disposition']?.split('=')[1] || 'FoodReport.csv'}`);
    document.body.appendChild(link);
    link.click();
    // return response;
};

export const getFoodTotalExpenseService = async (fromDate: any, toDate: any) => {
    const response = await getProtectedInstance().get(
        `/report/food?from_date=${fromDate}&to_date=${toDate}`
    );
    return response;
};

export const getFoodCompanyExpenseService = async (fromDate: any, toDate: any, companyId: string) => {
    const response = await getProtectedInstance().get(
        `/report/company/${companyId}/food?from_date=${fromDate}&to_date=${toDate}`
    );
    return response;
}
